module.exports = __webpack_public_path__ + "static/media/AccelX.883af177.gif";